/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './AccountsTable.scss';

import React from 'react';
import { connect } from 'react-redux';
import { clone, filter, map, mapValues } from 'lodash';

import Toggle from '../../../../shared/Toggle/Toggle';

import { accountName, formatAccountNumber } from 'services/Formats';
import {
  groupAccountsByAccountType,
  determineAvailableAccountTypes
} from 'services/Accounts';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const AccountNumber = ({ account }) => (
  <td className="account-number">{formatAccountNumber(account)}</td>
);

const AccountNumberWithPermissions = WithUserPermissions(AccountNumber);

class AccountsTable extends React.Component {
  constructor(props) {
    super(props);

    const { productAccounts, accountsPreFilter } = this.props;

    this.productSubset = {};
    productAccounts.forEach(
      (account) =>
        (this.productSubset[account.accountId] =
          accountsPreFilter.subset[account.accountId])
    );

    this.state = {
      numProductsSelected: filter(this.productSubset, (x) => x).length,
      productSubset: this.productSubset
    };

    this.selectionChange = this.selectionChange.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
  }

  selectionChange(accountId, toggled) {
    const tempAccounts = clone(this.state.productSubset);
    tempAccounts[accountId] = toggled;

    this.setState({
      productSubset: tempAccounts,
      numProductsSelected: filter(tempAccounts, (x) => x).length
    });

    if (this.props.onChange) {
      this.props.onChange(accountId, toggled);
    }
  }

  toggleAll() {
    let tempAccounts = clone(this.state.productSubset);
    const numTurnedOn = filter(tempAccounts, (account) => account).length;
    const areAllOn = numTurnedOn === map(tempAccounts).length;

    tempAccounts = mapValues(tempAccounts, () => !areAllOn);

    this.setState({
      productSubset: tempAccounts,
      numProductsSelected: filter(tempAccounts, (x) => x).length
    });

    if (this.props.onChange) {
      this.props.onChange(Object.keys(tempAccounts), !areAllOn);
    }
  }

  render() {
    const COL_TOGGLE_STATUS_CLASS = 'toggle-status';

    const { productName, productAccounts, tableClassName } = this.props;

    const groupedAccountsByAccountType =
      groupAccountsByAccountType(productAccounts);
    const availableAccountTypes =
      determineAvailableAccountTypes(productAccounts);

    return (
      <table className="accounts-table">
        <thead>
          <tr className="columns">
            <th className={`product-name-col ${tableClassName || ''}`}>
              {productName}
            </th>
            <th className={COL_TOGGLE_STATUS_CLASS}>
              <div className="toggle-all" onClick={this.toggleAll}>
                Toggle All
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {availableAccountTypes.map((accountType) => {
            return (
              <>
                <tr className="account-type-row">
                  <td className="account-type-text">{accountType}</td>
                  <td />
                </tr>
                {groupedAccountsByAccountType[accountType].map(
                  (account, index) => {
                    return (
                      <tr className="column-data" key={account.accountId}>
                        <td className="fund-name">
                          {accountName(account)}
                          <br />
                          <span className="fund-subtitle">
                            <AccountNumberWithPermissions
                              account={account}
                              shouldMask
                            />
                            {account.owners &&
                              account.owners.length &&
                              ` • ${account.owners[0].ownerName}`}
                          </span>
                        </td>
                        <td className="toggle">
                          <Toggle
                            onChange={this.selectionChange}
                            accountId={account.accountId}
                            selected={
                              this.state.productSubset[account.accountId]
                            }
                            index={index}
                          />
                        </td>
                      </tr>
                    );
                  }
                )}
              </>
            );
          })}
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  const { accountsById, selections } = state;
  const { accountsPreFilter } = selections;

  return {
    accountsById,
    accountsPreFilter
  };
};

export default connect(mapStateToProps)(AccountsTable);
